module.exports = __webpack_public_path__ + "img/profile-user.e89bd490.svg";